import { render } from "./AddOn.vue?vue&type=template&id=301d7005&scoped=true"
import script from "./AddOn.vue?vue&type=script&lang=js"
export * from "./AddOn.vue?vue&type=script&lang=js"

import "./AddOn.vue?vue&type=style&index=0&id=301d7005&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-301d7005"]])

export default __exports__